export enum HeadingLevel {
    MEGA = "mega",
    HERO = "hero",
    ONE = "h1",
    TWO = "h2",
    THREE = "h3",
    FOUR = "h4",
    FIVE = "h5",
    SIX = "h6"
}